import React from "react";
import Section from "./Section";
import "./FeaturesSection2.scss";

function FeaturesSection2(props) {
  const items = [
    {
      title: "Register Assets",
      description:
        "Upload files to your own cloud storage vault and register them as user-owned assets on Żetonium.",
      iconClass: "fas fa-upload",
      iconColor: "info",
    },
    {
      title: "Create License Deals",
      description:
        "Associate assets with custom smart licenses that define/govern usage and royalty terms for the data/IP between the asset owner and one or more counterparties.",
      iconClass: "fas fa-handshake",
      iconColor: "success",
    },
    {
      title: "Mint Tokens",
      description:
        "Create sets of unique, tradable Serialized Asset Tokens (SATs) that license the owner of the token to access linked/bundled data asset(s). Asset owners can license other accounts to mint tokens from their assets while stipulating usage and deal royalty terms.",
      iconClass: "fas fa-coins",
      iconColor: "primary",
    },
    {
      title: "Tag and classify data/IP assets",
      description:
        "Apply on-chain tags and classifiers to assets to establish relationships between different data/IP assets. Create complex information taxonomies, or bundle assets in collections and license them in bulk.",
      iconClass: "fas fa-tag",
      iconColor: "danger",
    },
    {
      title: "Certify asset authenticity",
      description:
        "Use tagging to certify the authenticity/provenance of an asset with an encrypted signature from a verified third party (and/or the asset rights holder). The certification is auditable on-chain and can provide a mechanism for additional royalty revenue to the certifier.",
      iconClass: "fas fa-file-signature",
      iconColor: "warning",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <div className="columns is-vcentered is-desktop">
          <div className="column">
            <figure className="FeaturesSection2__image image">
              <img src={props.image} alt="Illustration" />
            </figure>
          </div>
          <div className="column is-1" />
          <div className="column is-5-desktop features-container">
            {items.map((item, index) => (
              <div
                className="FeaturesSection2__feature columns is-vcentered is-variable is-4 is-mobile"
                key={index}
              >
                <div className="column is-narrow">
                  <div
                    className={`FeaturesSection2__icon icon has-text-${item.iconColor}`}
                  >
                    <i className={`${item.iconClass}`} />
                  </div>
                </div>
                <div className="column">
                  <h3 className="FeaturesSection2__title title has-text-weight-bold is-spaced is-5">
                    {item.title}
                  </h3>
                  <p className="subtitle is-6 has-text-grey">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection2;
